import axios from 'axios'

export default {
  state: {
    user: {},
    userAdmin: {},
    mexEcVisualizzato: false,
    autentication: {
      strong: 'strong',
      standard: 'local'
    },
    // userInc: {},
    spid: true,
    cie: true,
    local: true
  },
  mutations: {
    setUser(state, value) {
      // console.log('Aggiornato USER', value, state.user)
      state.user = value || {}

      // console.log('setUser state.user.userInc', state.user, state.user.hasOwnProperty('userInc'))
      if (!state.user.hasOwnProperty('userInc')) state.user.userInc = {}

      // if (value) {
      //   state.user = value
      // } else {
      //   state.user = null
      // }
      // console.log('User aggiornato', value, state.user)
    },
    setUserAdmin(state, value) {
      state.userAdmin = value || {}
    },

    setMessaggioEcVisualizzato(state, value) {
      state.mexEcVisualizzato = value || {}
    }
  },

  actions: {

    async login({ commit }, data) {
      try {
        // console.log('Login.commit', commit)
        // console.log('Login.data', data)
        // let rs = await axios.get('/api/auth/login', { params })
        // console.log('Before Login rs')
        let rs = await axios.post('/api/auth/login', data)
        console.log('Login rs', rs)
        commit('setUser', rs.data.user)
        commit('setMessaggioEcVisualizzato', false)
      } catch (err) {
        throw err
      }
    },

    async loginSpid({ commit }, data) {
      try {
        // console.log('LoginSpid.data', data)
        // console.log('Before Login rs')
        // let rs = await axios.post('/api/auth/loginSpid', data)
        await axios.get('/api/auth/loginSpid')

        // console.log('Login rs', rs)
        // commit('setUser', rs.data.user)
      } catch (err) {
        throw err
      }
    },

    async loginAdmin({ commit }, data) {
      try {
        // let rs = await axios.post('/api/auth/login', data)
        // let utente = {}
        let rs = null

        // console.log('loginAdmin', data)

        // if (['gianluca', 'francesco', 'alessandro'].find(ele => ele === data.username)) {
        //   // utente trovato
        //   if (data.password === 'AequaRoma') {
        //     // OK. password corretta
        //     // utente.codiceFiscale = ''
        //     // utente.codiceUtente = data.username
        //     // utente.cognome = data.username
        //     // utente.nome = 'PORTALE'
        //     // data.role = 'admin'
        //     data.username = data.username + '#' + 'admin'
        //     console.log('post(/api/auth/loginAdmin', data)
        //     rs = await axios.post('/api/auth/loginAdmin', data)
        //   } else {
        //     throw Error('Utente o password non validi!!')
        //   }
        // } else {
        //   throw Error('Utente o password non validi!!')
        // }

        data.username = data.username + '#' + 'admin'
        // console.log('post(/api/auth/loginAdmin', data)
        rs = await axios.post('/api/auth/loginAdmin', data)

        // commit('setUser', utente)
        // console.log('setUser', rs.data.user)
        commit('setUser', rs.data.user)
        commit('setUserAdmin', rs.data.user)
        // console.log('After setUserAdmin', this.state.auth.user.codiceUtente)
      } catch (err) {
        throw err
      }
    },

    async changeMobile({ commit }, data) {
      try {
        // console.log('changeMobile.commit', commit)
        // console.log('changeMobile.data', data)
        // eslint-disable-next-line no-unused-vars
        let rs = await axios.post('/api/auth/changeMobile', data)
        // commit('setUser', rs.data.user)
        // console.log('changeMobile.rs', rs)
      } catch (err) {
        throw err
      }
    },

    async changePassword({ commit }, data) {
      try {
        // console.log('changePassword.commit', commit)
        // console.log('changePassword.data', data)
        // eslint-disable-next-line no-unused-vars
        let rs = await axios.post('/api/auth/changePassword', data)
        // commit('setUser', rs.data.user)
        // console.log('changePassword.rs', rs)
      } catch (err) {
        throw err
      }
    },

    async userRegistration({ commit }, data) {
      try {
        // console.log('userRegistration.commit', commit)
        // console.log('userRegistration.data', data)
        // eslint-disable-next-line no-unused-vars
        let rs = await axios.post('/api/auth/userRegistration', data)
        // commit('setUser', rs.data.user)
        // console.log('userRegistration.rs', rs)
      } catch (err) {
        throw err
      }
    },

    async recuperaPassword({ commit }, data) {
      try {
        // console.log('recuperaPassword.commit', commit)
        // console.log('recuperaPassword.data', data)

        await axios.post('/api/auth/recuperaPassword', data)

        // commit('setUser', rs.data.user)
        // console.log('recuperaPassword.rs', !!rs)
      } catch (err) {
        throw err
      }
    },

    async info({ commit }) {
      try {
        let rs = await axios.get('/api/auth/info')
        // console.log('info rs.data.user', rs.data.user)
        // console.log('info rs.data.user.hasOwnProperty(userInc)', rs.data.user.hasOwnProperty('userInc'))
        commit('setUser', rs.data.user)
        // if (rs.data && rs.data.user && rs.data.user.hasOwnProperty('userInc')) {
        //   commit('setUserInc', rs.data.user.userInc)
        // }
      } catch (err) {
        throw err
      }
    },

    async logout({ commit }) {
      try {
        await axios.get('/api/auth/logout')
        commit('setUser', null)
        commit('setUserAdmin', null)
        commit('setMessaggioEcVisualizzato', false)
        // commit('setUserInc', null)
        // console.log('Azzero user', this.state.auth.user)
      } catch (err) {
        throw err
      }
    }
  },

  getters: {
    hasLocal: state => {
      return state.local
    },
    hasSpid: state => {
      return state.spid
    },
    isAuthenticated: state => {
      // console.log('isAuthenticated: state.user, state.userAdmin => ', state.user, state.userAdmin)
      // console.log('isAuthenticated: state => ', state.user ? state.user.codiceUtente : null, state.userAdmin ? state.userAdmin.codiceUtente : null)
      // console.log('verifica utenti: state => ', state.user, state.userAdmin)
      return !!(state.user ? state.user.codiceUtente : null) || !!(state.userAdmin ? state.userAdmin.codiceUtente : null)
    },
    isIntermediario: state => {
      // console.log('isIntermediario: state.user, state.userInc => ', state.user.userInc ? state.user.userInc : null)
      // console.log('isIntermediario: state => ', state.user ? state.user.codiceUtente === 'intermediario' : null)
      return !!(state.user ? state.user.codiceUtente === 'intermediario' : null)
    },
    isMexEcRead: state => {
      return state.mexEcVisualizzato
    },
  }
}
